










<mat-card class="contact_holder">
   
    <mat-accordion class="contacts" >
        <mat-expansion-panel [expanded]="true" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Contact
            </mat-panel-title>
          </mat-expansion-panel-header>
          <button mat-icon-button color="primary" class="addbtn" [ngClass]="{'actived': addnewContact}" (click)="addShare(shareAdd)"  ><mat-icon>add</mat-icon></button>
          <!-- <div class="addcontact" *ngIf="addnewContact" > 
            <mat-form-field class="example-full-width">
                <input matInput
                       placeholder="Select Contact"
                       aria-label="State"
                       [matAutocomplete]="auto"
                       [formControl]="stateCtrl">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option  *ngFor="let state of filteredStates | async" [value]="state.name">
                    <span class="userlist" (click)="addNew()" fxLayout="row" fxLayoutAlign="flex-start center" >
                        <div class="pic">
                            <img class="" [src]="state.pic"/>
                        </div>
                        <span fxLayout="column" fxLayoutAlign="flex-start" > 
                            <b>{{state.name}} </b>
                            <small>{{state.email}}</small>
                        </span> 
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
        </div> -->
          <div class="bcard" fxLayout="row" >
            <div class="picinfo" (click)="contactDetail(showdetail)">
                <div class="userpic">
                    <img src="../../../../../assets/images/avatars/alice.jpg" alt="">
                </div>
                <div class="info">
                    <h4>Darren Cross</h4>
                    <p class="email" >yellowjacket@signashare.com</p>
                    <div class="chips">
                        <mat-chip-list aria-label="">
                            <mat-chip>Buyer <mat-icon matChipRemove >cancel</mat-icon></mat-chip>
                            <mat-chip color="primary" selected ><mat-icon>add</mat-icon></mat-chip>
                        </mat-chip-list>                       
                    </div>
                </div>
            </div>
            <mat-icon class="del">delete</mat-icon>
        </div>
    
        <div class="bcard"   fxLayout="column">
            <div class="picinfo" (click)="contactDetail(showdetail)" >
                <div class="userpic" >
                    <img src="../../../../../assets/images/avatars/Tillman.jpg" alt="">
                </div>
                <div class="info">
                    <h4 >Matt Macplin</h4>
                    <p class="email" >matt@gmail.com</p>
                    <div class="chips">
                        <mat-chip-list aria-label="">
                            <mat-chip>Buyer <mat-icon matChipRemove >cancel</mat-icon></mat-chip>
                            <mat-chip>Seller <mat-icon matChipRemove >cancel</mat-icon></mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
            </div>
            
            <mat-icon class="del" >delete</mat-icon>
        </div>
    
    
        </mat-expansion-panel>

        <mat-expansion-panel  >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Shared Access
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="bcard" fxLayout="row" >
            <div class="picinfo" (click)="contactDetail(showdetail)">
                <div class="userpic">
                    <img src="../../../../../assets/images/avatars/Arnold.jpg" alt="">
                </div>
                <div class="info">
                    <h4>Trevor </h4>
                    <p class="email" >trevor@signashare.com</p>
                    <div class="chips">
                        <mat-chip-list aria-label="">
                            <mat-chip>Buyer <mat-icon matChipRemove >cancel</mat-icon></mat-chip>
                            <mat-chip>Seller <mat-icon matChipRemove >cancel</mat-icon></mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
            </div>
            <mat-icon class="del">delete</mat-icon>
        </div>
    
        <div class="bcard"   fxLayout="column">
            <div class="picinfo" (click)="contactDetail(showdetail)" >
                <div class="userpic" >
                    <img src="../../../../../assets/images/avatars/Helen.jpg" alt="">
                </div>
                <div class="info">
                    <h4 >Emmalene</h4>
                    <p class="email" >emmalene@gmail.com</p>
                </div>
            </div>
            
            <mat-icon class="del" >delete</mat-icon>
        </div>
        </mat-expansion-panel >


        <mat-expansion-panel  >
            <mat-expansion-panel-header>
              <mat-panel-title>
                Company
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="bcard" fxLayout="row" >
                <div class="picinfo" (click)="contactDetail(showdetail)">
                    <div class="userpic">
                        <img src="../../../../../assets/images/avatars/Josefina.jpg" alt="">
                    </div>
                    <div class="info">
                        <h4>Nike</h4>
                        <p class="email" >nike@gmail.com</p>
                        <div class="chips">
                            <mat-chip-list aria-label="">
                                <mat-chip>Buyer <mat-icon matChipRemove >cancel</mat-icon></mat-chip>
                                <mat-chip>Seller <mat-icon matChipRemove >cancel</mat-icon></mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                </div>
                <mat-icon class="del">delete</mat-icon>
            </div>
        
            <div class="bcard"   fxLayout="column">
                <div class="picinfo" (click)="contactDetail(showdetail)" >
                    <div class="userpic" >
                        <img src="../../../../../assets/images/avatars/Mai.jpg" alt="">
                    </div>
                    <div class="info">
                        <h4 >ECM</h4>
                        <p class="email" >ecm@gmail.com</p>
                    </div>
                </div>
                
                <mat-icon class="del" >delete</mat-icon>
            </div>
          </mat-expansion-panel>
      </mat-accordion>
    





    <!-- <div class="contactlist"  >
        <div class="contacts">
            <div class="title">
                <h3>Contacts</h3>
                <button mat-mini-fab color="primary" class="add" [ngClass]="{'actived': addnewContact}" (click)="addContact()"  ><mat-icon>add</mat-icon></button>
            </div>
            <div class="list">

                <div class="addcontact" *ngIf="addnewContact" > 
                    <mat-form-field class="example-full-width">
                        <input matInput
                               placeholder="Select Contact"
                               aria-label="State"
                               [matAutocomplete]="auto"
                               [formControl]="stateCtrl">
                        <mat-autocomplete #auto="matAutocomplete">
                          <mat-option  *ngFor="let state of filteredStates | async" [value]="state.name">
                            <span class="userlist" (click)="addNew()" fxLayout="row" fxLayoutAlign="flex-start center" >
                                <div class="pic">
                                    <img class="" [src]="state.pic"/>
                                </div>
                                <span fxLayout="column" fxLayoutAlign="flex-start" > 
                                    <b>{{state.name}} </b>
                                    <small>{{state.email}}</small>
                                </span> 
                            </span>
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                </div>

                <div class="bcard" fxLayout="row" >
                    <div class="picinfo">
                        <div class="userpic">
                            <img src="../../../../../assets/images/avatars/alice.jpg" alt="">
                        </div>
                        <div class="info">
                            <h4>DARREN CROSS</h4>
                            <p class="email" >yellowjacket@signashare.com</p>
                            <p class="role">
                                <span class="addrole" [matMenuTriggerFor]="menu" >
                                   Add Role
                                </span>
                            </p>                          
                            <mat-menu #menu="matMenu" xPosition="before">
                              <button mat-menu-item> <mat-checkbox color="primary" ></mat-checkbox> Buyer</button>
                              <button mat-menu-item color="primary" ><mat-checkbox color="primary" ></mat-checkbox> Seller</button>
                              <button mat-menu-item color="primary"><mat-checkbox color="primary" ></mat-checkbox> Agent</button>
                            </mat-menu>
                        </div>
                    </div>
                    <mat-icon class="del">delete</mat-icon>
                </div>

                <div class="bcard"   fxLayout="column">
                    <div class="picinfo" (click)="contactDetail(showdetail)" >
                        <div class="userpic" >
                            <img src="../../../../../assets/images/avatars/Tillman.jpg" alt="">
                        </div>
                        <div class="info">
                            <h4 >Matt Macplin</h4>
                            <p class="email" >matt@gmail.com</p>
                        </div>
                    </div>
                    <p class="role" >Listing Agent 
                        <span class="addrole" [matMenuTriggerFor]="menu" >
                        <mat-icon>add</mat-icon>
                        </span>
                    </p>
                    <mat-icon class="del" >delete</mat-icon>
                </div>

            </div>
        </div>
        <div class="contacts">
            <div class="title">
                <h3>Shared Access</h3>
                <button mat-mini-fab color="primary" class="add" [ngClass]="{'actived': addnewSharedContact}" (click)="addSharedContact()"  ><mat-icon>add</mat-icon></button>
            </div>
            <div class="list">

                <div class="addcontact" *ngIf="addnewSharedContact" > 
                    <mat-form-field class="example-full-width">
                        <input matInput
                               placeholder="Select Contact"
                               aria-label="State"
                               [matAutocomplete]="auto"
                               [formControl]="stateCtrl">
                        <mat-autocomplete #auto="matAutocomplete">
                          <mat-option  *ngFor="let state of filteredStates | async" [value]="state.name">
                            <span class="userlist" (click)="addNew()" fxLayout="row" fxLayoutAlign="flex-start center" >
                                <div class="pic">
                                    <img class="" [src]="state.pic"/>
                                </div>
                                <span fxLayout="column" fxLayoutAlign="flex-start" > 
                                    <b>{{state.name}} </b>
                                    <small>{{state.email}}</small>
                                </span> 
                            </span>
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                </div>

                <div class="bcard" fxLayout="row" >
                    <div class="picinfo">
                        <div class="userpic">
                            <img src="../../../../../assets/images/avatars/alice.jpg" alt="">
                        </div>
                        <div class="info">
                            <h4>DARREN CROSS</h4>
                            <p class="email">yellowjacket@signashare.com</p>
                            <p class="role" >
                                <span class="addrole" [matMenuTriggerFor]="menu" >
                                   Add Role
                                </span>
                            </p>                          
                            <mat-menu #menu="matMenu" xPosition="before">
                              <button mat-menu-item> <mat-checkbox color="primary" ></mat-checkbox> Buyer</button>
                              <button mat-menu-item color="primary" ><mat-checkbox color="primary" ></mat-checkbox> Seller</button>
                              <button mat-menu-item color="primary"><mat-checkbox color="primary" ></mat-checkbox> Agent</button>
                            </mat-menu>
                        </div>
                    </div>
                    <mat-icon class="del">delete</mat-icon>
                </div>

                <div class="bcard"   fxLayout="column">
                    <div class="picinfo" (click)="contactDetail(showdetail)" >
                        <div class="userpic" >
                            <img src="../../../../../assets/images/avatars/Tillman.jpg" alt="">
                        </div>
                        <div class="info">
                            <h4 >Matt Macplin</h4>
                            <p class="email">matt@gmail.com</p>
                        </div>
                    </div>
                    <p class="role" >Listing Agent 
                        <span class="addrole" [matMenuTriggerFor]="menu" >
                        <mat-icon>add</mat-icon>
                        </span>
                    </p>
                    <mat-icon class="del" >delete</mat-icon>
                </div>

            </div>
        </div>
    </div> -->




    <!-- Developed structure -->

    <!-- <div class="bcard" fxLayout="row" *ngFor= "let contact of contactsList" >
        <div class="picinfo">
            <div class="userpic" (click)="contactDetail(showdetail)">
                <img src="../../../../../assets/images/avatars/Barrera.jpg" alt="">
            </div>
            <div class="info">
                <h3 (click)="contactDetail(showdetail)">{{contact.firstName}} {{contact.lastName}}</h3>
                <p>{{contact.email}}</p>
                <p>Listing Agent</p>
            </div>
        </div>
        <mat-icon>delete</mat-icon>
    </div> -->


    <!-- Developed structure -->




</mat-card>

<app-add-contact (closeAdd)="getClose($event)" [ngClass]="{'open': showAddContact}" ></app-add-contact>


<ng-template #shareAdd>
    <h2 mat-dialog-title>
       <span class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Add Contact or Role
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">
    

    <div class="radOpts">

        <mat-radio-group aria-label="Select an option" color="primary" >
            <mat-radio-button value="1">Contact</mat-radio-button>
            <mat-radio-button value="2">Role</mat-radio-button>
          </mat-radio-group>

    </div>

    <app-contactlist></app-contactlist>
  
  
    <ul class="selectedlist" >
      
      <li *ngFor="let user of peoples" >
        <div class="userndetail">
            <div class="pic">
              <img src="../../../assets/images/avatars/{{user.img}}" alt="" >
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon>cancel</mat-icon></button>
            </div>
        </div>
      </li>

    </ul>
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" >Done</button>
  </mat-dialog-actions>
  </ng-template>